import React from 'react';
import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-bottom: 1.5rem;
`;

export const SectionTitle = styled.h3`
  font-size: 1rem;
  color: #282828;
  margin: 0 0 0.5rem;
`;

export const FieldRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

export const CreatePanel = styled.div`
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 1rem;
  margin-top: 0.75rem;
  background-color: #fafafa;
`;

export const CreatePanelRow = styled.div`
  margin-bottom: 0.75rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const FileHint = styled.span`
  display: block;
  font-size: 0.75rem;
  color: #757575;
  margin-top: 0.25rem;
`;

export const FileError = styled.span`
  display: block;
  font-size: 0.8rem;
  color: #c62828;
  margin-top: 0.25rem;
`;

export const PreviewRow = styled.div`
  margin-top: 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

export const CompanyLogoPreview = styled.img`
  height: 48px;
  width: auto;
  max-width: 160px;
  object-fit: contain;
`;

export const ColorLabel = styled.span`
  font-size: 0.85rem;
  color: #616161;
`;

export const ColorSwatchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;

export const ColorSwatch = styled(({ isActive, swatchColor, ...rest }) => (
  <button type="button" {...rest} />
))`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: ${(props) => props.swatchColor || '#fff'};
  border: ${(props) => (props.isActive ? '3px solid #282828' : '1px solid #ccc')};
  cursor: pointer;
  padding: 0;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const ColorInput = styled.input`
  width: 36px;
  height: 28px;
  padding: 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const ColorCode = styled.code`
  font-size: 0.8rem;
  color: #616161;
`;
